import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { useState, useEffect } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from './../../utils/calculationDataValidation'
const calculatorType = 'Kosarka'
const Kosarka = () => {
  const [showInputArea, setShowInputArea] = useState(false)
  const [data, setData] = useState({
    values: {
      odds: ['', '', ''],
      teams: ['', '', '', '', '', ''],
    },
    results: {
      winningChances: ['', ''],
      expectedPoints: ['', '', ''],
      expectedDifference: ['', '', ''],
      expectedResult: ['', '', ''],
      betkoResult: [''],
      teamStrength: {
        home: {
          attack: '',
          defense: '',
        },
        away: {
          attack: '',
          defense: '',
        },
        combined: {
          attack: '',
          defense: '',
        },
        matchup: {
          homeAttack_vs_awayDefense: '',
          homeDefense_vs_awayAttack: '',
        },
      },
    },
  })
  const allFieldsFilled = areAllFieldsFilled(data.values)
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  //New Functions//
  const clearFields = () => {
    setData({
      values: {
        odds: ['', '', ''],
        teams: ['', '', '', '', '', ''],
      },
      results: {
        winningChances: ['', ''],
        expectedPoints: ['', '', ''],
        expectedDifference: ['', '', ''],
        expectedResult: ['', '', ''],
        betkoResult: [''],
        teamStrength: {
          home: {
            attack: '',
            defense: '',
          },
          away: {
            attack: '',
            defense: '',
          },
          combined: {
            attack: '',
            defense: '',
          },
          matchup: {
            homeAttack_vs_awayDefense: '',
            homeDefense_vs_awayAttack: '',
          },
        },
      },
    })
    setShowInputArea(false)
  }
  const handleButtonClick = () => {
    if (showInputArea) {
      clearFields()
      return
    } else {
      handleCalculate()
    }

    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  useEffect(() => {
    if (allFieldsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allFieldsFilled])

  const handleCalculate = () => {
    const [
      domacinDao,
      domacinPrimio,
      brojUtakmicaDomacin,
      gostDao,
      gostPrimio,
      brojUtakmicaGost,
    ] = data.values.teams.map(Number)

    const [pobedaDomacina, nereseno, pobedaGosta] = data.values.odds.map(Number)

    let snd = domacinDao / brojUtakmicaDomacin
    let sod = domacinPrimio / brojUtakmicaDomacin
    let sog = gostDao / brojUtakmicaGost
    let sng = gostPrimio / brojUtakmicaGost

    let sodg = (sod + sog) / 2
    let sndg = (snd + sng) / 2
    let sndsog = (snd + sog) / 2
    let sodsng = (sod + sng) / 2

    let h63 = pobedaDomacina
    let k63 = (1 / h63) * 100
    let i63 = nereseno
    let l63 = (1 / i63) * 100
    let j63 = pobedaGosta
    let m63 = (1 / j63) * 100
    let n63 = k63 + l63 + m63 - 100
    let o63 = k63 - n63 / 3
    let r63 = (o63 * n63) / 100
    let u63 = k63 - r63
    let p63 = l63 - n63 / 3
    let s63 = (p63 * n63) / 100
    let v63 = l63 - s63
    let l61 = v63 / 2
    let pobeda1 = u63 + l61
    let q63 = m63 - n63 / 3
    let t63 = (q63 * n63) / 100
    let w63 = m63 - t63
    let pobeda2 = l61 + w63

    let n67 = domacinDao
    let o67 = domacinPrimio
    let o69 = brojUtakmicaDomacin
    let o71 = (n67 + o67) / o69
    let p67 = gostPrimio
    let q67 = gostDao
    let q69 = brojUtakmicaGost
    let q71 = (p67 + q67) / q69
    let o73 = (o71 + q71) / 2
    let l60 = l63 - s63
    let p58 = o73 - o73 * 0.0102
    let p60 = p58
    let bd60 = p60 / 2
    let ag60 = pobeda1
    let ah60 = nereseno
    let aq60 = p60
    let ar60 = ag60 + ah60 / 2
    let at60 = (aq60 * ar60) / 100
    let ai60 = pobeda2
    let as60 = ai60 + ah60 / 2
    let au60 = (aq60 * as60) / 100
    let av60 = Math.round(at60)
    let ax60 = Math.round(au60)

    let poenimin = o73 - (l60 / 100) * p60
    let n60 = o73 - (l60 / 100) * p60
    let poenimax = p60 - n60 + p60
    let poenibalans = p60

    let k60 = u63
    let m60 = w63
    let max
    let min

    if (av60 > ax60) {
      max = av60
      min = ax60
    } else {
      max = ax60
      min = av60
    }

    let be60 = (max - min) / 5
    let bf60

    if (k60 >= m60) {
      bf60 = bd60 + be60 / 2
    } else {
      bf60 = bd60 - be60 / 2
    }

    let bg60

    if (bd60 > bf60) {
      bg60 = bd60 + be60 / 2
    } else {
      bg60 = bd60 - be60 / 2
    }

    let pobedasarazlikombalans = Math.round(bf60 - bg60)

    let pobedasarazlikommin = Math.round(
      pobedasarazlikombalans - pobedasarazlikombalans * 0.25
    )

    let pobedasarazlikommax = Math.round(
      pobedasarazlikombalans + pobedasarazlikombalans * 0.25
    )

    let o60 = (n60 + p60) / 2
    let betkovpredlog = o60.toFixed(2)

    let bk60 = n60 / 2
    let bl60 = be60
    let bm60

    if (k60 >= m60) {
      bm60 = bk60 + bl60 / 2
    } else {
      bm60 = bk60 - bl60 / 2
    }

    let tacanrez1dom = Math.round(bm60)
    let bn60

    if (bk60 > bm60) {
      bn60 = bk60 + bl60 / 2
    } else {
      bn60 = bk60 - bl60 / 2
    }

    let tacanrez1gost = Math.round(bn60)
    let tacanrez2dom = Math.round(bf60)
    let tacanrez2gost = Math.round(bg60)

    let q60 = p60 - n60 + p60
    let br60 = q60 / 2
    let bu60
    let bt60
    let bs60 = (max - min) / 5

    if (k60 >= m60) {
      bt60 = br60 + bs60 / 2
    } else {
      bt60 = br60 - bs60 / 2
    }

    if (br60 > bt60) {
      bu60 = br60 + bs60 / 2
    } else {
      bu60 = br60 - bs60 / 2
    }

    let tacanrez3gost = Math.round(bu60)
    let tacanrez3dom = Math.round(bt60)

    setData((prev) => ({
      ...prev,
      results: {
        winningChances: [pobeda1.toFixed(2), '', pobeda2.toFixed(2)],
        expectedPoints: [
          poenimin.toFixed(2),
          poenibalans.toFixed(2),
          poenimax.toFixed(2),
        ],
        expectedDifference: [
          pobedasarazlikommin,
          pobedasarazlikombalans,
          pobedasarazlikommax,
        ],
        expectedResult: [
          `${tacanrez1dom} : ${tacanrez1gost}`,
          `${tacanrez2dom} : ${tacanrez2gost}`,
          `${tacanrez3dom} : ${tacanrez3gost}`,
        ],
        betkoResult: [betkovpredlog],
        teamStrength: {
          home: {
            attack: snd.toFixed(2),
            defense: sod.toFixed(2),
          },
          away: {
            attack: sng.toFixed(2),
            defense: sog.toFixed(2),
          },
          combined: {
            attack: sndg.toFixed(2),
            defense: sodg.toFixed(2),
          },
          matchup: {
            homeAttack_vs_awayDefense: sndsog.toFixed(2),
            homeDefense_vs_awayAttack: sodsng.toFixed(2),
          },
        },
      },
    }))
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleButtonClick} disabled={disabled}>
            {showInputArea ? 'Unesi obračunske podatke' : 'Prikaži rezultate'}
          </button>
        </div>
        {!showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod utakmice
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field={'odds'}
              labelPrefix={['KI 1', 'KI X', 'KI 2']}
              type={['number', 'number', 'number']}
              min={['0.1', '0.1', '0.1']}
              step={['0.1', '0.1', '0.1']}
              rows={3}
              setError={setError}
            />
            <div className={classesK.sectionTitle}>
              <span>Upiši br. poena / br. ut. za oba tima</span>
            </div>
            <OddsCalculator
              field={'teams'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'DOM +  ( dom. dao poena)',
                'DOM -  ( dom. primio poena)',
                'DOM BR. ( dom. odigrao utakmica)',
                'GOST +  ( gost. dao poena)',
                'GOST -  ( gost. primio poena)',
                'GOST BR. ( gost. odigrao utakmica)',
              ]}
              step={['1', '1', '1', '1', '1', '1']}
              min={['0', '0', '0', '0', '0', '0']}
              type={[
                'number',
                'number',
                'number',
                'number',
                'number',
                'number',
              ]}
              style={{ appearance: 'auto' }}
              rows={3}
              setError={setError}
            />
          </>
        )}

        {showInputArea && (
          <div>
            <ResultsSection
              title={'Ishod utakmice'}
              subtitle={'Konačan ishod'}
              results={[
                data.results.winningChances[0]
                  ? `${data.results.winningChances[0]}%`
                  : '-',
                data.results.winningChances[2]
                  ? `${data.results.winningChances[2]}%`
                  : '-',
              ]}
              names={['KI 1', 'KI 2']}
              withPercent
            />
            <div>
              <ResultsSection
                title='Granice broja poena'
                subtitle={'Predlozi predikcija br. poena'}
                results={data.results.expectedPoints}
                names={[
                  'Minimalni očekivani broj poena',
                  'Srednji očekivani broj poena',
                  'Maksimalni očekivani broj poena',
                ]}
              />
            </div>
            <div>
              <ResultsSection
                title={'Pobeda sa razlikom'}
                subtitle={'Pobeda favorizovanog tima sa razlikom'}
                names={[
                  'Minimalna očekivana razlika u poenima',
                  'Srednja očekivana razlika u poenima',
                  'Maksimalni očekivani broj poena',
                ]}
                breakLastItem
                results={
                  Array.isArray(data.results.expectedDifference)
                    ? data.results.expectedDifference
                    : []
                }
              />
            </div>
            <div>
              <ResultsSection
                title={'Tačan rezultat'}
                subtitle={'Opciono mogući tačan rezultat'}
                names={[
                  'Predikcija minimalnog tačnog rezultata',
                  'Predikcija srednjeg tačnog rezultata',
                  'Predikcija maksimalnog tačnog rezultata',
                ]}
                results={
                  Array.isArray(data.results.expectedResult)
                    ? data.results.expectedResult
                    : []
                }
                breakLastItem
              />
            </div>
            <div>
              <ResultsSection
                title={'Betko predlog'}
                subtitle={'Betko predlog za igru na "Plus poene"'}
                names={['+ ( na ut.će biti više od prikazanog br.poena)']}
                results={
                  Array.isArray(data.results.betkoResult)
                    ? data.results.betkoResult
                    : []
                }
              />
            </div>
            <div>
              <ResultsSection
                title={'Snage timova'}
                subtitle={`Snaga domaćina`}
                results={[
                  data.results.teamStrength.home.attack,
                  data.results.teamStrength.home.defense,
                ]}
                withPercent={false}
                names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
              />
              <ResultsSection
                subtitle={`Snaga gosta`}
                results={[
                  data.results.teamStrength.away.attack,
                  data.results.teamStrength.away.defense,
                ]}
                withPercent={false}
                names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
              />
              <ResultsSection
                subtitle={`Snage oba tima zajedno`}
                results={[
                  data.results.teamStrength.combined.attack,
                  data.results.teamStrength.combined.defense,
                ]}
                withPercent={false}
                names={[
                  'SNDG ( snaga napada domaćina i gosta )',
                  'SODG ( snaga odbrane domaćina i gosta )',
                ]}
              />
              <ResultsSection
                subtitle={`Tim proseci odbrana i napada`}
                results={[
                  data.results.teamStrength.matchup.homeAttack_vs_awayDefense,
                  data.results.teamStrength.matchup.homeDefense_vs_awayAttack,
                ]}
                withPercent={false}
                names={[
                  'SND + SOG ( dom. daje/gost prima )',
                  'SND + SOD ( dom. prima/gost daje )',
                ]}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Kosarka
